import { render, staticRenderFns } from "./DepartmentTreeRadiosChild.vue?vue&type=template&id=a18ce96c&"
import script from "./DepartmentTreeRadiosChild.vue?vue&type=script&lang=js&"
export * from "./DepartmentTreeRadiosChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports